import { render, staticRenderFns } from "./Payments-Billing.vue?vue&type=template&id=2ca121dc&scoped=true&"
import script from "./Payments-Billing.vue?vue&type=script&lang=js&"
export * from "./Payments-Billing.vue?vue&type=script&lang=js&"
import style0 from "./Payments-Billing.vue?vue&type=style&index=0&id=2ca121dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca121dc",
  null
  
)

export default component.exports